import * as ActionTypes from '../SignOut';
import { fetchClientInfo } from '../../creators/client';
export function signOut() {
    return function (dispatch) {
        dispatch(fetchClientInfo());
        return dispatch({ type: ActionTypes.SIGNOUT });
    };
}



// WEBPACK FOOTER //
// ./src/actions/auth/creators/SignOut.js